import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { loginCookie, removeloginCookie, setAllUserInfo, setUserInfo } from "../../services/auth";
import { serverMessages, serverMessagesLogin } from "../serverMessages";
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { getActiveGroupAPI, getActiveSpecialityAPI, getAllModuleTokenWithUserAPI, getAllTableUserAPI, getGroupModuleAPI,  getRecoverPasswordAPI,  getUserAssociatedAPI,  getUserInfoByTokenAPI,  getUserOdontologicoAPI,  postLoginAPI, postRegisterUserAsyncAPI, updatepasswordAPI, updateStatusUserAsyncAPI, updateUserAsyncAPI ,getPathologicalHistoryAPI, getStatusOrganizationAPI,getCIE10ByFilterAPI, getValidateTokenAPI, putUpdatePasswordUserAPI} from "./restCallUser";
import { UserLoginState } from "./types";


//

export const putUpdatePasswordUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putUpdatePasswordUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizado", "Contraseña actualizada")
        return responseData.Response
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getValidateToken = (value: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getValidateTokenAPI(value);
    if (responseData.Error !== null) {
        window.location.replace(process.env.REACT_APP_BASE_URL as string);

    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getCIE10ByFilter= (filter:string, value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getCIE10ByFilterAPI(filter, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getStatusOrganization = (): AppThunk => async (dispatch) => {
    dispatch(setMessageResponse(null));
    const responseData = await getStatusOrganizationAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        if(responseData.Response.status != "ACTIVO"){
            removeloginCookie();
              window.location.replace(process.env.REACT_APP_BASE_URL as string+"/error-server");
        }

        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPathologicalHistory = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPathologicalHistoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getUserInfoByToken = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserInfoByTokenAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getUserOdontologico = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserOdontologicoAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getUserAssociated = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserAssociatedAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updatepassword = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await updatepasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Proceso ejcutado"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getRecoverPassword = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getRecoverPasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getActiveSpeciality = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getActiveSpecialityAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getActiveGroup = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getActiveGroupAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllTableUser = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllTableUserAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postRegisterUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postRegisterUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Usuario "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updateUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await updateUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Usuario "+validateMessages.updateSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updateStatusUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await updateStatusUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Usuario "+validateMessages.updateSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postAccountLoginUser = (accountLoginState: UserLoginState): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postLoginAPI(accountLoginState);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessagesLogin(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        
        loginCookie(responseData.Response.access_token);
        const token = {
            token: responseData.Response.access_token   
        };
        const userinfo = await getUserInfoByTokenAPI(token);
        setUserInfo(userinfo.Response);    
        setAllUserInfo(userinfo.Response);
        const responseDataRespone = await getAllModuleTokenWithUserAPI(token);

        window.location.replace(process.env.REACT_APP_BASE_URL as string+"/"+responseDataRespone.Response[0].link);
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllModuleToken = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGroupModuleAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};